import { getAppServices } from 'conversations/services'

export const log = (entry: any) => getAppServices().util.log(entry)

export const info = (message: string, options?: { [key: string]: any }) =>
  log({ level: 'info', message, ...options })

export const warn = (message: string, options?: { [key: string]: any }) =>
  log({ level: 'warn', message, ...options })

export const error = (message: string, error?: Error, options?: { [key: string]: any }) =>
  log({ level: 'error', message, error, ...options })

export default { log, info, warn, error }
